// components/features/tickets/TicketSaveModal.tsx
import { useState } from "react";
import TicketForm from "./TicketForm";
import { Ticket } from "../../../../types/features/support/Ticket";
import BaseModal from "../../../ui/Modal";
import { ticketService } from "../../../../services/support/ticketService";

interface TicketSaveModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  initialData?: Ticket;
}

export default function TicketSaveModal({ isOpen, onClose, onSuccess, initialData }: TicketSaveModalProps) {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (data: Omit<Ticket, "id" | "created_at" | "updated_at">) => {
    setIsLoading(true);

    // Simuler un appel API
    await ticketService.createTicket(data);
    setIsLoading(false);
    onSuccess();
    onClose();
  };

  const title = initialData ? "Modifier le ticket" : "Nouveau ticket";

  return (
    <BaseModal isOpen={isOpen} onClose={onClose} title={title}>
      <TicketForm initialData={initialData} onSubmit={handleSubmit} isLoading={isLoading} />
    </BaseModal>
  );
}
